import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { NotificationsService } from '@core/services/notifications.service';

export const NEW_FORM_ROUTE_PARAM = 'add';
export const NEW_FORM_KEY_ID = -1;
export const HIDDEN_ITEM_SEQUENCE_ORDER = -1;

export const commonCatchErrorHandler = (): ((error: HttpErrorResponse) => Observable<null>) => {
  const notificationsService = inject(NotificationsService);
  return ({ error, url }: HttpErrorResponse) => {
    notificationsService.showError(error?.error ?? error?.message ?? 'An error has occurred', url);
    return of(null);
  };
};

export enum OfficeRelatedPathsEnum {
  inquiries = 'inquiries',
  reportgateway = 'reportgateway',
}
